const TCG_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwGxr5jtimcxfAtGrwqIo4P_Hwbyt_s_fCURioem9MU_vWD2f6am7ZK5XeRGntTzjcm/exec';

class TCGTradeInForm {
  constructor() {
    this.currentStep = 1;
    this.formData = {
      card_name: '',
      card_set: '',
      card_number: '',
      card_rarity: '',
      condition: '',
      condition_multiplier: 1.0,
      photos: [],
      customer_name: '',
      customer_email: '',
      customer_phone: '',
      delivery_method: 'Spedizione'
    };
    this.init();
  }

  init() {
    document.querySelectorAll('.condition-card').forEach(card => {
      card.addEventListener('click', () => this.selectCondition(card));
    });

    ['card_name', 'card_set', 'card_number', 'card_rarity'].forEach(field => {
      const input = document.getElementById(field);
      if (input) input.addEventListener('change', () => { this.formData[field] = input.value; });
    });
  }

  selectCondition(card) {
    document.querySelectorAll('.condition-card').forEach(c => c.classList.remove('selected'));
    card.classList.add('selected');
    this.formData.condition = card.dataset.condition;
    this.formData.condition_multiplier = parseFloat(card.dataset.multiplier);
    this.updateEstimate();
  }

  updateEstimate() {
    const estimateBox = document.querySelector('.estimate-value');
    if (estimateBox) {
      estimateBox.textContent = 'In attesa di valutazione';
      estimateBox.style.fontSize = '18px';
    }
  }
}

let tradeInForm;
document.addEventListener('DOMContentLoaded', () => {
  tradeInForm = new TCGTradeInForm();
});

function nextStep() {
  const currentStepEl = document.querySelector(`.form-step[data-step="${tradeInForm.currentStep}"]`);
  if (!validateStep(tradeInForm.currentStep)) return;

  currentStepEl.classList.remove('active');
  document.querySelector(`.progress-step[data-step="${tradeInForm.currentStep}"]`).classList.remove('active');
  document.querySelector(`.progress-step[data-step="${tradeInForm.currentStep}"]`).classList.add('completed');

  tradeInForm.currentStep++;
  const nextStepEl = document.querySelector(`.form-step[data-step="${tradeInForm.currentStep}"]`);
  nextStepEl.classList.add('active');
  document.querySelector(`.progress-step[data-step="${tradeInForm.currentStep}"]`).classList.add('active');

  if (tradeInForm.currentStep === 4) updateSummary();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function prevStep() {
  const currentStepEl = document.querySelector(`.form-step[data-step="${tradeInForm.currentStep}"]`);
  currentStepEl.classList.remove('active');
  document.querySelector(`.progress-step[data-step="${tradeInForm.currentStep}"]`).classList.remove('active');

  tradeInForm.currentStep--;
  const prevStepEl = document.querySelector(`.form-step[data-step="${tradeInForm.currentStep}"]`);
  prevStepEl.classList.add('active');
  document.querySelector(`.progress-step[data-step="${tradeInForm.currentStep}"]`).classList.add('active');
  document.querySelector(`.progress-step[data-step="${tradeInForm.currentStep}"]`).classList.remove('completed');

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function validateStep(step) {
  switch(step) {
    case 1:
      const cardName = document.getElementById('card_name').value.trim();
      const cardSet = document.getElementById('card_set').value.trim();
      const cardRarity = document.getElementById('card_rarity').value;
      if (!cardName || !cardSet || !cardRarity) { alert('Compila tutti i campi obbligatori'); return false; }
      tradeInForm.formData.card_name = cardName;
      tradeInForm.formData.card_set = cardSet;
      tradeInForm.formData.card_number = document.getElementById('card_number').value.trim();
      tradeInForm.formData.card_rarity = cardRarity;
      return true;

    case 2:
      if (!tradeInForm.formData.condition) { alert('Seleziona la condizione della carta'); return false; }
      return true;

    case 3:
      if (tradeInForm.formData.photos.length < 3) { alert('Carica almeno 3 foto della carta'); return false; }
      return true;

    case 4:
      const customerName = document.getElementById('customer_name').value.trim();
      const customerEmail = document.getElementById('customer_email').value.trim();
      const customerPhone = document.getElementById('customer_phone').value.trim();
      const acceptTerms = document.getElementById('accept_terms').checked;
      if (!customerName || !customerEmail || !customerPhone) { alert('Compila tutti i campi obbligatori'); return false; }
      if (!acceptTerms) { alert('Devi accettare i termini e condizioni'); return false; }
      tradeInForm.formData.customer_name = customerName;
      tradeInForm.formData.customer_email = customerEmail;
      tradeInForm.formData.customer_phone = customerPhone;
      tradeInForm.formData.delivery_method = document.querySelector('input[name="delivery_method"]:checked').value;
      return true;

    default: return true;
  }
}

function handlePhotoUpload(photoIndex) {
  const input = document.getElementById(`photo_${photoIndex}`);
  const file = input.files[0];
  if (!file) return;

  if (!file.type.startsWith('image/')) { alert('Carica solo immagini (JPG, PNG)'); input.value = ''; return; }
  if (file.size > 5 * 1024 * 1024) { alert('Immagine troppo grande. Massimo 5MB'); input.value = ''; return; }

  const reader = new FileReader();
  reader.onload = function(e) {
    const base64 = e.target.result;
    const existingIndex = tradeInForm.formData.photos.findIndex(p => p.index === photoIndex);
    if (existingIndex >= 0) tradeInForm.formData.photos[existingIndex] = { index: photoIndex, data: base64 };
    else tradeInForm.formData.photos.push({ index: photoIndex, data: base64 });

    const photoBox = document.querySelector(`.photo-upload-box[data-photo="${photoIndex}"]`);
    const preview = photoBox.querySelector('.photo-preview');
    preview.innerHTML = `<img src="${base64}" alt="Foto ${photoIndex}"><button type="button" class="remove-photo" onclick="removePhoto(${photoIndex})">✕</button>`;
    photoBox.classList.add('has-photo');
  };
  reader.readAsDataURL(file);
}

function removePhoto(photoIndex) {
  tradeInForm.formData.photos = tradeInForm.formData.photos.filter(p => p.index !== photoIndex);
  const input = document.getElementById(`photo_${photoIndex}`);
  input.value = '';
  const photoBox = document.querySelector(`.photo-upload-box[data-photo="${photoIndex}"]`);
  photoBox.querySelector('.photo-preview').innerHTML = '';
  photoBox.classList.remove('has-photo');
}

function updateSummary() {
  document.getElementById('summary_card_name').textContent = tradeInForm.formData.card_name;
  document.getElementById('summary_card_set').textContent = tradeInForm.formData.card_set;
  document.getElementById('summary_card_number').textContent = tradeInForm.formData.card_number || 'N/A';
  document.getElementById('summary_card_rarity').textContent = tradeInForm.formData.card_rarity;
  document.getElementById('summary_condition').textContent = tradeInForm.formData.condition;
  document.getElementById('summary_photos').textContent = `${tradeInForm.formData.photos.length} foto`;
}

async function submitTradeIn() {
  if (!validateStep(4)) return;

  const submitBtn = document.querySelector('.btn-submit');
  submitBtn.disabled = true;
  submitBtn.textContent = 'Invio in corso...';

  // ✅ AGGIORNATO: action tcg_create + URL unificato
  const payload = {
    action: 'tcg_create',
    card_name: tradeInForm.formData.card_name,
    card_set: tradeInForm.formData.card_set,
    card_number: tradeInForm.formData.card_number,
    card_rarity: tradeInForm.formData.card_rarity,
    condition: tradeInForm.formData.condition,
    customer_name: tradeInForm.formData.customer_name,
    customer_email: tradeInForm.formData.customer_email,
    customer_phone: tradeInForm.formData.customer_phone,
    delivery_method: tradeInForm.formData.delivery_method,
    photos: `${tradeInForm.formData.photos.length} foto caricate`,
    estimated_value: '0.00',
  };

  try {
    const res = await fetch(TCG_SCRIPT_URL, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    const result = await res.json();

    const savedRequests = JSON.parse(localStorage.getItem('tcg_trade_in_requests') || '[]');
    savedRequests.push({ id: result.request_number, date: new Date().toISOString(), card: tradeInForm.formData.card_name });
    localStorage.setItem('tcg_trade_in_requests', JSON.stringify(savedRequests));

    showSuccessScreen(result.request_number);
  } catch (error) {
    console.error('Errore invio:', error);
    alert('Errore durante l\'invio. Riprova.');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Invia Richiesta';
  }
}

function showSuccessScreen(requestId) {
  document.querySelector('.form-step[data-step="4"]').classList.remove('active');
  document.querySelector('.form-step[data-step="success"]').classList.add('active');
  document.querySelector('.progress-bar').style.display = 'none';
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
